import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "tabs_tn1",
  class: "py-1"
}
const _hoisted_2 = { class: "w-full p-0" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-[18px] items-start md:grid-cols-12" }
const _hoisted_4 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_5 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_6 = {
  key: 1,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_7 = { class: "flex min-h-[42px] items-center gap-4 rounded-lg border border-slate-300 bg-white px-3" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = {
  key: 2,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "m-0 font-medium text-slate-800" }
const _hoisted_14 = {
  key: 3,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_15 = {
  key: 4,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_16 = {
  key: 5,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_17 = { class: "min-w-0 md:col-span-12" }
const _hoisted_18 = { class: "mt-1 flex items-center md:col-span-12" }
const _hoisted_19 = {
  id: "tabs_tn2",
  class: "py-1"
}
const _hoisted_20 = { class: "w-full p-0" }
const _hoisted_21 = { class: "mb-4 grid grid-cols-1 gap-[18px] items-start md:grid-cols-12" }
const _hoisted_22 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_23 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_24 = {
  key: 1,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_25 = { class: "flex min-h-[42px] items-center gap-4 rounded-lg border border-slate-300 bg-white px-3" }
const _hoisted_26 = { class: "flex items-center gap-2" }
const _hoisted_27 = { class: "flex items-center gap-2" }
const _hoisted_28 = {
  key: 2,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_29 = { class: "flex items-center gap-2" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "m-0 font-medium text-slate-800" }
const _hoisted_32 = {
  key: 3,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_33 = {
  key: 4,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_34 = {
  key: 5,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_35 = { class: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr)_360px]" }
const _hoisted_36 = { class: "flex flex-col gap-4" }
const _hoisted_37 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_38 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_39 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_40 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_41 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_42 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_43 = { class: "flex w-full items-center gap-2" }
const _hoisted_44 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_45 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_46 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_47 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_48 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_49 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_50 = { class: "flex w-full items-center gap-2" }
const _hoisted_51 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_52 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_53 = {
  key: 1,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_54 = {
  key: 2,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_55 = {
  key: 3,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_56 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_57 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_58 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_59 = { class: "flex w-full items-center gap-2" }
const _hoisted_60 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_61 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_62 = {
  key: 1,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_63 = {
  key: 2,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_64 = {
  key: 3,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_65 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_66 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_67 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_68 = { class: "flex w-full items-center gap-2" }
const _hoisted_69 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_70 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_71 = {
  key: 1,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_72 = {
  key: 2,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_73 = {
  key: 3,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_74 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_75 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_76 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_77 = { class: "flex w-full items-center gap-2" }
const _hoisted_78 = { class: "flex min-w-0 flex-col md:col-span-6" }
const _hoisted_79 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_80 = {
  key: 1,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_81 = {
  key: 2,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_82 = {
  key: 3,
  class: "flex min-w-0 flex-col md:col-span-6"
}
const _hoisted_83 = { class: "mt-1 flex items-center" }
const _hoisted_84 = { class: "xl:sticky xl:top-24 xl:self-start" }
const _hoisted_85 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_12px_30px_rgba(15,23,42,0.08)]" }
const _hoisted_86 = { class: "mx-auto w-full max-w-[320px] overflow-hidden rounded-[20px] border border-slate-300 bg-slate-100 shadow-lg" }
const _hoisted_87 = { class: "bg-white" }
const _hoisted_88 = { class: "aspect-[16/9] bg-slate-200" }
const _hoisted_89 = ["src"]
const _hoisted_90 = {
  key: 1,
  class: "flex h-full w-full flex-col items-center justify-center gap-2 text-slate-400"
}
const _hoisted_91 = { class: "border-b border-slate-100 p-3" }
const _hoisted_92 = { class: "line-clamp-2 text-[15px] font-extrabold leading-5 text-slate-900" }
const _hoisted_93 = { class: "mt-1 line-clamp-3 text-[13px] leading-5 text-slate-600" }
const _hoisted_94 = { class: "divide-y divide-slate-100" }
const _hoisted_95 = { class: "h-12 w-12 shrink-0 overflow-hidden rounded-md bg-slate-100" }
const _hoisted_96 = ["src"]
const _hoisted_97 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center text-slate-400"
}
const _hoisted_98 = { class: "min-w-0 flex-1" }
const _hoisted_99 = { class: "line-clamp-2 text-[13px] font-bold leading-5 text-slate-900" }
const _hoisted_100 = {
  key: 0,
  class: "mt-0.5 line-clamp-2 text-xs leading-4 text-slate-500"
}
const _hoisted_101 = {
  key: 0,
  class: "p-3 text-[13px] font-medium leading-5 text-slate-500"
}
const _hoisted_102 = { class: "contents" }
const _hoisted_103 = { class: "w-full" }
const _hoisted_104 = { id: "loading" }
const _hoisted_105 = {
  key: 0,
  class: "w-full"
}
const _hoisted_106 = { class: "mb-5 flex flex-col gap-4 md:flex-row md:items-center" }
const _hoisted_107 = { class: "min-w-0 flex-1" }
const _hoisted_108 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_109 = { class: "group flex h-full min-w-0 flex-col rounded-lg border border-slate-200 bg-white p-3 shadow-sm transition hover:border-teal-200 hover:shadow-md" }
const _hoisted_110 = ["onClick"]
const _hoisted_111 = ["src"]
const _hoisted_112 = ["title"]
const _hoisted_113 = { class: "mt-3 flex items-center gap-2" }
const _hoisted_114 = { class: "flex flex-col gap-4" }
const _hoisted_115 = ["disabled"]
const _hoisted_116 = {
  key: 0,
  class: "overflow-hidden rounded-lg border border-slate-200"
}
const _hoisted_117 = { class: "flex items-center justify-between gap-3 border-b border-slate-200 bg-slate-50 px-4 py-3" }
const _hoisted_118 = { class: "divide-y divide-slate-100" }
const _hoisted_119 = { class: "flex min-w-0 items-center gap-3" }
const _hoisted_120 = { class: "min-w-0" }
const _hoisted_121 = { class: "truncate text-sm font-semibold text-slate-900" }
const _hoisted_122 = { class: "text-xs font-medium text-slate-500" }
const _hoisted_123 = { class: "flex justify-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TabView, null, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { header: "Gởi tin nhắn thông thường" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[65] || (_cache[65] = _createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)),
                    _createVNode(_component_Dropdown, {
                      id: "kind",
                      modelValue: $setup.action,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.action) = $event)),
                      options: $setup.lsAction,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  ($setup.action == 'location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _cache[66] || (_cache[66] = _createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)),
                        _createVNode(_component_Dropdown, {
                          id: "location",
                          modelValue: $setup.province,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.province) = $event)),
                          options: $setup.listProvince,
                          optionLabel: "provinceName",
                          optionValue: "provinceCode",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'gender')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[69] || (_cache[69] = _createElementVNode("label", null, "A3. Giới tính ", -1)),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _withDirectives(_createElementVNode("input", {
                              class: "m-0 h-4 w-4 accent-teal-600",
                              type: "radio",
                              id: "nam",
                              name: "sex",
                              value: "Nam",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.gender) = $event))
                            }, null, 512), [
                              [_vModelRadio, $setup.gender]
                            ]),
                            _cache[67] || (_cache[67] = _createElementVNode("label", {
                              for: "nam",
                              class: "m-0 min-h-0 font-semibold leading-none text-slate-900"
                            }, "Nam", -1))
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _withDirectives(_createElementVNode("input", {
                              class: "m-0 h-4 w-4 accent-teal-600",
                              type: "radio",
                              id: "nu",
                              name: "sex",
                              value: "Nữ",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.gender) = $event))
                            }, null, 512), [
                              [_vModelRadio, $setup.gender]
                            ]),
                            _cache[68] || (_cache[68] = _createElementVNode("label", {
                              for: "nu",
                              class: "m-0 min-h-0 font-semibold leading-none text-slate-900"
                            }, "Nữ", -1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'customer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[70] || (_cache[70] = _createElementVNode("label", null, "Chọn khách hàng gởi", -1)),
                        _createVNode(_component_MultiSelect, {
                          modelValue: $setup.listIdMessage,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.listIdMessage) = $event)),
                          options: $setup.listCustomer,
                          optionLabel: "name",
                          placeholder: "Chọn tài khoản",
                          filter: true
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_11, [
                              (slotProps.option.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: slotProps.option.imageUrl,
                                    class: "h-10 w-10 rounded-md object-cover"
                                  }, null, 8, _hoisted_12))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_13, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'age')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age), 1),
                        _cache[71] || (_cache[71] = _createElementVNode("h5", null, null, -1)),
                        _createVNode(_component_Slider, {
                          modelValue: $setup.age,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.age) = $event)),
                          range: true
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[72] || (_cache[72] = _createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)),
                        _createVNode(_component_Dropdown, {
                          id: "group",
                          modelValue: $setup.idGroup,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.idGroup) = $event)),
                          options: $setup.listGroup,
                          optionLabel: "groupName",
                          optionValue: "id",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'civilgroup')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[73] || (_cache[73] = _createElementVNode("label", null, "Chọn tổ nhận tin", -1)),
                        _createVNode(_component_MultiSelect, {
                          id: "civil-group",
                          modelValue: $setup.selectCivilGroup,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.selectCivilGroup) = $event)),
                          options: $setup.listCivilGroup,
                          optionLabel: "civilGroupName",
                          placeholder: "Chọn một hoặc nhiều tổ",
                          filter: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[74] || (_cache[74] = _createElementVNode("label", null, "Nội dung tin nhắn", -1)),
                    _createVNode(_component_Textarea, {
                      id: "message",
                      type: "text",
                      modelValue: $setup.message.mess,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.message.mess) = $event)),
                      placeholder: "Nhập nội dung tin nhắn",
                      class: "min-h-[112px]"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Button, {
                      label: "Gởi tin nhắn",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.doSendMessage())),
                      loading: $setup.loadingBar,
                      disabled: !$setup.valid()
                    }, null, 8, ["loading", "disabled"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Gởi tin nhắn theo mẫu đính kèm" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[75] || (_cache[75] = _createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)),
                    _createVNode(_component_Dropdown, {
                      id: "kind2",
                      modelValue: $setup.action2,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.action2) = $event)),
                      options: $setup.lsAction,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  ($setup.action2 == 'location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _cache[76] || (_cache[76] = _createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)),
                        _createVNode(_component_Dropdown, {
                          id: "location2",
                          modelValue: $setup.province2,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.province2) = $event)),
                          options: $setup.listProvince,
                          optionLabel: "provinceName",
                          optionValue: "provinceCode",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'gender')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _cache[79] || (_cache[79] = _createElementVNode("label", null, "A3. Giới tính ", -1)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _withDirectives(_createElementVNode("input", {
                              class: "m-0 h-4 w-4 accent-teal-600",
                              type: "radio",
                              id: "nam2",
                              name: "sex",
                              value: "Nam",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.gender2) = $event))
                            }, null, 512), [
                              [_vModelRadio, $setup.gender2]
                            ]),
                            _cache[77] || (_cache[77] = _createElementVNode("label", {
                              for: "nam2",
                              class: "m-0 min-h-0 font-semibold leading-none text-slate-900"
                            }, "Nam", -1))
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              class: "m-0 h-4 w-4 accent-teal-600",
                              type: "radio",
                              id: "nu2",
                              name: "sex",
                              value: "Nữ",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.gender2) = $event))
                            }, null, 512), [
                              [_vModelRadio, $setup.gender2]
                            ]),
                            _cache[78] || (_cache[78] = _createElementVNode("label", {
                              for: "nu2",
                              class: "m-0 min-h-0 font-semibold leading-none text-slate-900"
                            }, "Nữ", -1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'customer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _cache[80] || (_cache[80] = _createElementVNode("label", null, "Chọn khách hàng gởi", -1)),
                        _createVNode(_component_MultiSelect, {
                          modelValue: $setup.listId,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.listId) = $event)),
                          options: $setup.listCustomer,
                          optionLabel: "name",
                          placeholder: "Chọn tài khoản",
                          filter: true
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_29, [
                              (slotProps.option.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: slotProps.option.imageUrl,
                                    class: "h-10 w-10 rounded-md object-cover"
                                  }, null, 8, _hoisted_30))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_31, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _cache[81] || (_cache[81] = _createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)),
                        _createVNode(_component_Dropdown, {
                          id: "group2",
                          modelValue: $setup.idGroup2,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.idGroup2) = $event)),
                          options: $setup.listGroup,
                          optionLabel: "groupName",
                          optionValue: "id",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'civilgroup')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _cache[82] || (_cache[82] = _createElementVNode("label", null, "Chọn tổ nhận tin", -1)),
                        _createVNode(_component_MultiSelect, {
                          id: "civil-group2",
                          modelValue: $setup.selectCivilGroup2,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.selectCivilGroup2) = $event)),
                          options: $setup.listCivilGroup,
                          optionLabel: "civilGroupName",
                          placeholder: "Chọn một hoặc nhiều tổ",
                          filter: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'age')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age2), 1),
                        _cache[83] || (_cache[83] = _createElementVNode("h5", null, null, -1)),
                        _createVNode(_component_Slider, {
                          modelValue: $setup.age2,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.age2) = $event)),
                          range: true
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_Panel, { header: "Thiết kế khung chính của tin nhắn" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _cache[84] || (_cache[84] = _createElementVNode("label", null, "Tiêu đề của khung chính", -1)),
                                _createVNode(_component_Textarea, {
                                  id: "titleMain",
                                  type: "text",
                                  modelValue: $setup.element1.title,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.element1.title) = $event)),
                                  placeholder: "Nhập tiêu đề khung chính"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _cache[85] || (_cache[85] = _createElementVNode("label", null, "Nội dung khung chính", -1)),
                                _createVNode(_component_Textarea, {
                                  id: "subtitleMain",
                                  type: "text",
                                  modelValue: $setup.element1.subtitle,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.element1.subtitle) = $event)),
                                  placeholder: "Nhập nội dung khung chính"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _cache[86] || (_cache[86] = _createElementVNode("label", null, "Đường dẫn hình ảnh chính", -1)),
                                _createElementVNode("div", _hoisted_43, [
                                  _createVNode(_component_InputText, {
                                    id: "imageUrlMain",
                                    type: "text",
                                    modelValue: $setup.element1.image_url,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.element1.image_url) = $event)),
                                    placeholder: "Chọn hoặc nhập đường dẫn hình ảnh chính"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_Button, {
                                    label: "Chọn hình",
                                    icon: "pi pi-image",
                                    iconPos: "left",
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.showListImage(1)))
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _cache[87] || (_cache[87] = _createElementVNode("label", null, "Đường dẫn khung chính", -1)),
                                _createVNode(_component_InputText, {
                                  id: "defaultUrl",
                                  type: "text",
                                  modelValue: $setup.element1.url,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.element1.url) = $event)),
                                  placeholder: "Nhập đường dẫn khi người dùng bấm vào khung chính"
                                }, null, 8, ["modelValue"])
                              ]),
                              _cache[88] || (_cache[88] = _createElementVNode("div", { class: "flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800 md:col-span-12" }, [
                                _createElementVNode("span", { class: "pi pi-info-circle mt-0.5" }),
                                _createElementVNode("span", null, "Lưu ý: Các trường trong khung chính bắt buộc phải nhập.")
                              ], -1))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Panel, { header: "Thiết kế thành phần" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_Accordion, {
                              multiple: true,
                              activeIndex: [0, 1]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AccordionTab, { header: "Tham số 1" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("div", _hoisted_48, [
                                        _cache[89] || (_cache[89] = _createElementVNode("label", null, "Tiêu đề của tham số 1", -1)),
                                        _createVNode(_component_InputText, {
                                          id: "title1",
                                          type: "text",
                                          modelValue: $setup.element2.title,
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.element2.title) = $event)),
                                          placeholder: "Nhập tiêu đề tham số 1"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_49, [
                                        _cache[90] || (_cache[90] = _createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 1", -1)),
                                        _createElementVNode("div", _hoisted_50, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl1",
                                            type: "text",
                                            modelValue: $setup.element2.image_url,
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.element2.image_url) = $event)),
                                            placeholder: "Chọn hoặc nhập đường dẫn hình ảnh tham số 1"
                                          }, null, 8, ["modelValue"]),
                                          _createVNode(_component_Button, {
                                            label: "Chọn hình",
                                            icon: "pi pi-image",
                                            iconPos: "left",
                                            onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.showListImage(2)))
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_51, [
                                        _cache[91] || (_cache[91] = _createElementVNode("label", null, "Loại hành động tham số 1", -1)),
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element2.type,
                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.element2.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element2.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                            _cache[92] || (_cache[92] = _createElementVNode("label", null, "Đường dẫn của tham số 1", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl1",
                                              type: "text",
                                              modelValue: $setup.element2.url,
                                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.element2.url) = $event)),
                                              placeholder: "Nhập đường dẫn của tham số 1"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element2.type == 2 || $setup.element2.type == 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                            _cache[93] || (_cache[93] = _createElementVNode("label", null, "Nội dung tin nhắn của tham số 1", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "automessage",
                                              type: "text",
                                              modelValue: $setup.element2.payload,
                                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.element2.payload) = $event)),
                                              placeholder: "Nhập nội dung tin nhắn của tham số 1"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element2.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                            _cache[94] || (_cache[94] = _createElementVNode("label", null, "Nội dung tin nhắn sms 1", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "smscontent",
                                              type: "text",
                                              modelValue: $setup.payload1.content,
                                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.payload1.content) = $event)),
                                              placeholder: "Nhập nội dung SMS tham số 1"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element2.type == 4 || $setup.element2.type == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                            _cache[95] || (_cache[95] = _createElementVNode("label", null, "Thông tin số điện thoại 1", -1)),
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload1.phone_code,
                                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.payload1.phone_code) = $event)),
                                              placeholder: "Nhập số điện thoại"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_AccordionTab, { header: "Tham số 2" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _cache[96] || (_cache[96] = _createElementVNode("label", null, "Tiêu đề của tham số 2", -1)),
                                        _createVNode(_component_InputText, {
                                          id: "title2",
                                          type: "text",
                                          modelValue: $setup.element3.title,
                                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.element3.title) = $event)),
                                          placeholder: "Nhập tiêu đề tham số 2"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_58, [
                                        _cache[97] || (_cache[97] = _createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 2", -1)),
                                        _createElementVNode("div", _hoisted_59, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl2",
                                            type: "text",
                                            modelValue: $setup.element3.image_url,
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.element3.image_url) = $event)),
                                            placeholder: "Chọn hoặc nhập đường dẫn hình ảnh tham số 2"
                                          }, null, 8, ["modelValue"]),
                                          _createVNode(_component_Button, {
                                            label: "Chọn hình",
                                            icon: "pi pi-image",
                                            iconPos: "left",
                                            onClick: _cache[33] || (_cache[33] = ($event: any) => ($setup.showListImage(3)))
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_60, [
                                        _cache[98] || (_cache[98] = _createElementVNode("label", null, "Loại hành động tham số 2", -1)),
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element3.type,
                                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.element3.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element3.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                            _cache[99] || (_cache[99] = _createElementVNode("label", null, "Đường dẫn của tham số 2", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl2",
                                              type: "text",
                                              modelValue: $setup.element3.url,
                                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.element3.url) = $event)),
                                              placeholder: "Nhập đường dẫn của tham số 2"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element3.type == 2 || $setup.element3.type == 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _cache[100] || (_cache[100] = _createElementVNode("label", null, "Nội dung tin nhắn của tham số 2", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "automessage2",
                                              type: "text",
                                              modelValue: $setup.element3.payload,
                                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.element3.payload) = $event)),
                                              placeholder: "Nhập nội dung tin nhắn của tham số 2"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element3.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                            _cache[101] || (_cache[101] = _createElementVNode("label", null, "Nội dung tin nhắn sms 2", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "smscontent2",
                                              type: "text",
                                              modelValue: $setup.payload2.content,
                                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.payload2.content) = $event)),
                                              placeholder: "Nhập nội dung SMS tham số 2"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element3.type == 4 || $setup.element3.type == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                            _cache[102] || (_cache[102] = _createElementVNode("label", null, "Thông tin số điện thoại 2", -1)),
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload2.phone_code,
                                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.payload2.phone_code) = $event)),
                                              placeholder: "Nhập số điện thoại"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_AccordionTab, { header: "Tham số 3" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_65, [
                                      _createElementVNode("div", _hoisted_66, [
                                        _cache[103] || (_cache[103] = _createElementVNode("label", null, "Tiêu đề của tham số 3", -1)),
                                        _createVNode(_component_InputText, {
                                          id: "title3",
                                          type: "text",
                                          modelValue: $setup.element4.title,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.element4.title) = $event)),
                                          placeholder: "Nhập tiêu đề tham số 3"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_67, [
                                        _cache[104] || (_cache[104] = _createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 3", -1)),
                                        _createElementVNode("div", _hoisted_68, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl3",
                                            type: "text",
                                            modelValue: $setup.element4.image_url,
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.element4.image_url) = $event)),
                                            placeholder: "Chọn hoặc nhập đường dẫn hình ảnh tham số 3"
                                          }, null, 8, ["modelValue"]),
                                          _createVNode(_component_Button, {
                                            label: "Chọn hình",
                                            icon: "pi pi-image",
                                            iconPos: "left",
                                            onClick: _cache[41] || (_cache[41] = ($event: any) => ($setup.showListImage(4)))
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_69, [
                                        _cache[105] || (_cache[105] = _createElementVNode("label", null, "Loại hành động tham số 3", -1)),
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element4.type,
                                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.element4.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element4.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                            _cache[106] || (_cache[106] = _createElementVNode("label", null, "Đường dẫn của tham số 3", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl3",
                                              type: "text",
                                              modelValue: $setup.element4.url,
                                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.element4.url) = $event)),
                                              placeholder: "Nhập đường dẫn của tham số 3"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element4.type == 2 || $setup.element4.type == 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                            _cache[107] || (_cache[107] = _createElementVNode("label", null, "Nội dung tin nhắn của tham số 3", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "automessage3",
                                              type: "text",
                                              modelValue: $setup.element4.payload,
                                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.element4.payload) = $event)),
                                              placeholder: "Nhập nội dung tin nhắn của tham số 3"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element4.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                            _cache[108] || (_cache[108] = _createElementVNode("label", null, "Nội dung tin nhắn sms 3", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "smscontent3",
                                              type: "text",
                                              modelValue: $setup.payload3.content,
                                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.payload3.content) = $event)),
                                              placeholder: "Nhập nội dung SMS tham số 3"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element4.type == 4 || $setup.element4.type == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                            _cache[109] || (_cache[109] = _createElementVNode("label", null, "Thông tin số điện thoại 3", -1)),
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload3.phone_code,
                                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.payload3.phone_code) = $event)),
                                              placeholder: "Nhập số điện thoại"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_AccordionTab, { header: "Tham số 4" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_74, [
                                      _createElementVNode("div", _hoisted_75, [
                                        _cache[110] || (_cache[110] = _createElementVNode("label", null, "Tiêu đề của tham số 4", -1)),
                                        _createVNode(_component_InputText, {
                                          id: "title4",
                                          type: "text",
                                          modelValue: $setup.element5.title,
                                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (($setup.element5.title) = $event)),
                                          placeholder: "Nhập tiêu đề tham số 4"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_76, [
                                        _cache[111] || (_cache[111] = _createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 4", -1)),
                                        _createElementVNode("div", _hoisted_77, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl4",
                                            type: "text",
                                            modelValue: $setup.element5.image_url,
                                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (($setup.element5.image_url) = $event)),
                                            placeholder: "Chọn hoặc nhập đường dẫn hình ảnh tham số 4"
                                          }, null, 8, ["modelValue"]),
                                          _createVNode(_component_Button, {
                                            label: "Chọn hình",
                                            icon: "pi pi-image",
                                            iconPos: "left",
                                            onClick: _cache[49] || (_cache[49] = ($event: any) => ($setup.showListImage(5)))
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_78, [
                                        _cache[112] || (_cache[112] = _createElementVNode("label", null, "Loại hành động tham số 4", -1)),
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element5.type,
                                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (($setup.element5.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element5.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                            _cache[113] || (_cache[113] = _createElementVNode("label", null, "Đường dẫn của tham số 4", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl4",
                                              type: "text",
                                              modelValue: $setup.element5.url,
                                              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.element5.url) = $event)),
                                              placeholder: "Nhập đường dẫn của tham số 4"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element5.type == 2 || $setup.element5.type == 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                            _cache[114] || (_cache[114] = _createElementVNode("label", null, "Nội dung tin nhắn của tham số 4", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "automessage4",
                                              type: "text",
                                              modelValue: $setup.element5.payload,
                                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.element5.payload) = $event)),
                                              placeholder: "Nhập nội dung tin nhắn của tham số 4"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element5.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                            _cache[115] || (_cache[115] = _createElementVNode("label", null, "Nội dung tin nhắn sms 4", -1)),
                                            _createVNode(_component_InputText, {
                                              id: "smscontent4",
                                              type: "text",
                                              modelValue: $setup.payload4.content,
                                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (($setup.payload4.content) = $event)),
                                              placeholder: "Nhập nội dung SMS tham số 4"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element5.type == 4 || $setup.element5.type == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                            _cache[116] || (_cache[116] = _createElementVNode("label", null, "Thông tin số điện thoại 4", -1)),
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload4.phone_code,
                                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (($setup.payload4.phone_code) = $event)),
                                              placeholder: "Nhập số điện thoại"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_83, [
                      _createVNode(_component_Button, {
                        label: "Gởi tin nhắn",
                        icon: "pi pi-plus-circle",
                        iconPos: "left",
                        onClick: _cache[55] || (_cache[55] = ($event: any) => ($setup.doSendMessageWithAttachment())),
                        loading: $setup.loadingBar,
                        disabled: !$setup.valid2()
                      }, null, 8, ["loading", "disabled"])
                    ])
                  ]),
                  _createElementVNode("aside", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _cache[120] || (_cache[120] = _createElementVNode("div", { class: "mb-3 flex items-center justify-between" }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", { class: "text-[15px] font-extrabold text-slate-900" }, " Xem trước tin nhắn sẽ được gởi "),
                          _createElementVNode("div", { class: "text-[13px] font-medium text-slate-500" }, " Cập nhật theo nội dung đang nhập ")
                        ]),
                        _createElementVNode("span", { class: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-teal-50 text-teal-700" }, [
                          _createElementVNode("i", { class: "pi pi-mobile text-sm" })
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_86, [
                        _cache[119] || (_cache[119] = _createElementVNode("div", { class: "flex h-10 items-center gap-2 bg-teal-700 px-3 text-white" }, [
                          _createElementVNode("i", { class: "pi pi-chevron-left text-xs" }),
                          _createElementVNode("div", { class: "min-w-0 flex-1 truncate text-[13px] font-bold" }, " Zalo OA Preview "),
                          _createElementVNode("i", { class: "pi pi-ellipsis-h text-xs" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("div", _hoisted_88, [
                            ($setup.element1.image_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: $setup.element1.image_url,
                                  class: "h-full w-full object-cover",
                                  alt: ""
                                }, null, 8, _hoisted_89))
                              : (_openBlock(), _createElementBlock("div", _hoisted_90, [...(_cache[117] || (_cache[117] = [
                                  _createElementVNode("i", { class: "pi pi-image text-2xl" }, null, -1),
                                  _createElementVNode("span", { class: "text-[13px] font-semibold" }, "Ảnh chính", -1)
                                ]))]))
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, _toDisplayString($setup.element1.title || "Tiêu đề khung chính"), 1),
                            _createElementVNode("div", _hoisted_93, _toDisplayString($setup.element1.subtitle ||
                          "Nội dung khung chính sẽ hiển thị tại đây."), 1)
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.previewElements, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.key,
                                class: "flex gap-3 p-3"
                              }, [
                                _createElementVNode("div", _hoisted_95, [
                                  (item.image_url)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: item.image_url,
                                        class: "h-full w-full object-cover",
                                        alt: ""
                                      }, null, 8, _hoisted_96))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_97, [...(_cache[118] || (_cache[118] = [
                                        _createElementVNode("i", { class: "pi pi-image text-sm" }, null, -1)
                                      ]))]))
                                ]),
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("div", _hoisted_99, _toDisplayString(item.title || item.fallbackTitle), 1),
                                  (item.description)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(item.description), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128)),
                            ($setup.previewElements.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_101, " Các tham số sẽ hiển thị tại đây sau khi nhập tiêu đề hoặc chọn ảnh. "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_102, [
      _createElementVNode("div", _hoisted_103, [
        _createVNode(_component_Dialog, {
          header: "Gởi tin nhắn",
          visible: $setup.loadingBar,
          "onUpdate:visible": _cache[56] || (_cache[56] = ($event: any) => (($setup.loadingBar) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_104, [
              _cache[121] || (_cache[121] = _createElementVNode("label", null, "Đang gởi tin nhắn, vui lòng chờ ...", -1)),
              _createVNode(_component_ProgressBar, {
                mode: "indeterminate",
                class: "h-[0.3em]"
              })
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_ConfirmDialog)
      ]),
      ($setup.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
            _createVNode(_component_Dialog, {
              header: "Tập tin lưu trên máy chủ",
              visible: $setup.show,
              "onUpdate:visible": _cache[59] || (_cache[59] = ($event: any) => (($setup.show) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createVNode(_component_InputText, {
                      id: "find",
                      type: "text",
                      modelValue: $setup.find,
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (($setup.find) = $event)),
                      onInput: _cache[58] || (_cache[58] = ($event: any) => ($setup.search($event))),
                      placeholder: "Tìm kiếm"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _createVNode(_component_Button, {
                      label: "Xóa hình",
                      onClick: $setup.deleteImage,
                      icon: "pi pi-trash",
                      class: "w-fit",
                      disabled: !$setup.validImageSelect()
                    }, null, 8, ["onClick", "disabled"]),
                    _createVNode(_component_Button, {
                      label: "Upload ảnh",
                      icon: "pi pi-upload",
                      outlined: "",
                      class: "w-fit",
                      onClick: $setup.openUploadImageDialog
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _createVNode(_component_DataView, {
                  value: $setup.listImageFull,
                  layout: $setup.layout,
                  paginator: true,
                  rows: 20,
                  sortOrder: _ctx.sortOrder,
                  sortField: _ctx.sortField
                }, {
                  grid: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex aspect-[4/3] w-full items-center justify-center overflow-hidden rounded-lg bg-slate-100",
                        onClick: ($event: any) => ($setup.imageClick(slotProps.data.link))
                      }, [
                        _createElementVNode("img", {
                          class: "h-full w-full object-cover transition group-hover:scale-[1.02]",
                          src: slotProps.data.link,
                          alt: ""
                        }, null, 8, _hoisted_111)
                      ], 8, _hoisted_110),
                      _createElementVNode("div", {
                        class: "mt-2 line-clamp-2 min-h-[32px] break-words text-xs font-medium leading-4 text-slate-700",
                        title: slotProps.data.fileName
                      }, _toDisplayString(slotProps.data.fileName), 9, _hoisted_112),
                      _createElementVNode("div", _hoisted_113, [
                        _createVNode(_component_Checkbox, {
                          modelValue: slotProps.data.delete,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.delete) = $event),
                          binary: true
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _cache[122] || (_cache[122] = _createElementVNode("span", { class: "text-xs font-medium text-slate-500" }, "Chọn", -1))
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "layout", "sortOrder", "sortField"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_Dialog, {
              header: "Upload ảnh từ máy của bạn",
              visible: $setup.showUploadImageDialog,
              "onUpdate:visible": _cache[64] || (_cache[64] = ($event: any) => (($setup.showUploadImageDialog) = $event)),
              modal: "",
              style: { width: 'min(720px, calc(100vw - 32px))' }
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_123, [
                  _createVNode(_component_Button, {
                    label: "Hủy",
                    icon: "pi pi-times",
                    severity: "secondary",
                    outlined: "",
                    onClick: $setup.closeUploadImageDialog,
                    disabled: $setup.uploadingImages
                  }, null, 8, ["onClick", "disabled"]),
                  _createVNode(_component_Button, {
                    label: "Đăng ảnh",
                    icon: "pi pi-cloud-upload",
                    onClick: $setup.upload,
                    loading: $setup.uploadingImages,
                    disabled: $setup.uploadingImages || $setup.listFileName.length < 1
                  }, null, 8, ["onClick", "loading", "disabled"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "flex min-h-[180px] flex-col items-center justify-center gap-3 rounded-lg border-2 border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center transition hover:border-teal-400 hover:bg-teal-50/40",
                    onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => ($setup.triggerLocalImagePicker && $setup.triggerLocalImagePicker(...args))),
                    onDragover: _cache[61] || (_cache[61] = _withModifiers(() => {}, ["prevent"])),
                    onDrop: _cache[62] || (_cache[62] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleImageDrop && $setup.handleImageDrop(...args)), ["prevent"]))
                  }, [...(_cache[123] || (_cache[123] = [
                    _createElementVNode("span", { class: "inline-flex h-12 w-12 items-center justify-center rounded-lg bg-teal-50 text-xl text-teal-700" }, [
                      _createElementVNode("i", { class: "pi pi-cloud-upload" })
                    ], -1),
                    _createElementVNode("span", { class: "text-[15px] font-bold text-slate-900" }, " Kéo ảnh vào đây hoặc bấm để chọn ảnh ", -1),
                    _createElementVNode("span", { class: "text-sm font-medium text-slate-500" }, " Hỗ trợ JPG, JPEG, PNG. Có thể chọn nhiều ảnh cùng lúc. ", -1)
                  ]))], 32),
                  _createElementVNode("input", {
                    ref: "uploadImageInputEl",
                    type: "file",
                    class: "hidden",
                    accept: ".jpeg,.png,.jpg",
                    multiple: "",
                    onChange: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => ($setup.handleUploadImageInputChange && $setup.handleUploadImageInputChange(...args))),
                    disabled: $setup.uploadingImages
                  }, null, 40, _hoisted_115),
                  ($setup.listFileName.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _cache[124] || (_cache[124] = _createElementVNode("div", { class: "text-sm font-bold text-slate-900" }, " Tệp tin đã chọn ", -1)),
                          _createVNode(_component_Button, {
                            label: "Xóa tất cả",
                            icon: "pi pi-trash",
                            severity: "danger",
                            text: "",
                            onClick: $setup.clearUploadFiles,
                            disabled: $setup.uploadingImages
                          }, null, 8, ["onClick", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listFileName, (file) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: file.nameFile,
                              class: "flex items-center justify-between gap-3 px-4 py-3"
                            }, [
                              _createElementVNode("div", _hoisted_119, [
                                _cache[125] || (_cache[125] = _createElementVNode("span", { class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" }, [
                                  _createElementVNode("i", { class: "pi pi-image" })
                                ], -1)),
                                _createElementVNode("div", _hoisted_120, [
                                  _createElementVNode("div", _hoisted_121, _toDisplayString(file.nameFile), 1),
                                  _createElementVNode("div", _hoisted_122, _toDisplayString($setup.formatFileSize(file.value?.size)), 1)
                                ])
                              ]),
                              _createVNode(_component_Button, {
                                label: "Xóa",
                                icon: "pi pi-trash",
                                severity: "danger",
                                outlined: "",
                                class: "!min-h-[34px] px-3 py-1.5",
                                onClick: ($event: any) => ($setup.deleteUploadFile(file.nameFile)),
                                disabled: $setup.uploadingImages
                              }, null, 8, ["onClick", "disabled"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}